/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ source: NonNullable<unknown> }} Client_Lead_Source_LabelInputs */

const en_client_lead_source_label = /** @type {(inputs: Client_Lead_Source_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.source === "social_media") return /** @type {LocalizedString} */ (`Social media`);
	if (i?.source === "referral") return /** @type {LocalizedString} */ (`Referral`);
	if (i?.source === "online_search") return /** @type {LocalizedString} */ (`Online search`);
	if (i?.source === "sales_consultant") return /** @type {LocalizedString} */ (`Sales consultant`);
	return /** @type {LocalizedString} */ (`${i?.source}`)
	
};

const pt_br2_client_lead_source_label = /** @type {(inputs: Client_Lead_Source_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.source === "social_media") return /** @type {LocalizedString} */ (`Mídias sociais`);
	if (i?.source === "referral") return /** @type {LocalizedString} */ (`Indicação`);
	if (i?.source === "online_search") return /** @type {LocalizedString} */ (`Busca online`);
	if (i?.source === "sales_consultant") return /** @type {LocalizedString} */ (`Consultor comercial`);
	return /** @type {LocalizedString} */ (`${i?.source}`)
	
};

/**
* | source | output |
* | --- | --- |
* | "social_media" | "Social media" |
* | "referral" | "Referral" |
* | "online_search" | "Online search" |
* | "sales_consultant" | "Sales consultant" |
* | * | "{source}" |
*
* @param {Client_Lead_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_lead_source_label = /** @type {((inputs: Client_Lead_Source_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Lead_Source_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_lead_source_label(inputs)
	return pt_br2_client_lead_source_label(inputs)
});